import { SuccessResponse } from 'shared/api/auth/auth.types'

export interface PasswordRecoveryCheckRequest {
  token: string
}

export type PasswordRecoveryCheckResponse = SuccessResponse<string>
